import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Make stores globally available for testing
import { useProfileStore } from './store/profile.store';
import { useAuthStore } from './store/auth.store';

if (typeof window !== 'undefined') {
  window.useProfileStore = useProfileStore;
  window.useAuthStore = useAuthStore;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);












